import { render, staticRenderFns } from "./ActingCapture.vue?vue&type=template&id=ae2fbe2e&scoped=true&"
import script from "./ActingCapture.vue?vue&type=script&lang=js&"
export * from "./ActingCapture.vue?vue&type=script&lang=js&"
import style0 from "./ActingCapture.vue?vue&type=style&index=0&id=ae2fbe2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2fbe2e",
  null
  
)

export default component.exports